// extracted by mini-css-extract-plugin
module.exports = {"disable-mobile-icon-drag":"styles_disable-mobile-icon-drag__hRkrj"};